/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PositionType = {
    REPORT: 'report',
    PRE_TRADE: 'pre_trade'
} as const;
export type PositionType = typeof PositionType[keyof typeof PositionType];


export function instanceOfPositionType(value: any): boolean {
    for (const key in PositionType) {
        if (Object.prototype.hasOwnProperty.call(PositionType, key)) {
            if (PositionType[key as keyof typeof PositionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PositionTypeFromJSON(json: any): PositionType {
    return PositionTypeFromJSONTyped(json, false);
}

export function PositionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PositionType {
    return json as PositionType;
}

export function PositionTypeToJSON(value?: PositionType | null): any {
    return value as any;
}

export function PositionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PositionType {
    return value as PositionType;
}

